var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    fill: "none",
    viewBox: "0 0 24 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.885 9.79a4.191 4.191 0 1 0 0 8.384 4.191 4.191 0 0 0 0-8.383m-5.914 4.192a5.914 5.914 0 1 1 11.828 0 5.914 5.914 0 0 1-11.828 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.885 6.92a7.062 7.062 0 1 0 0 14.124 7.062 7.062 0 0 0 0-14.124M3.1 13.982a8.785 8.785 0 1 1 17.57 0 8.785 8.785 0 0 1-17.57 0",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.191 4.738a2.47 2.47 0 0 0-2.469 2.469v10.105a2.47 2.47 0 0 0 2.47 2.47h3.444a.861.861 0 1 1 0 1.722H4.191A4.194 4.194 0 0 1 0 17.312V7.207a4.194 4.194 0 0 1 4.191-4.191H19.81A4.194 4.194 0 0 1 24 7.207v10.105a4.194 4.194 0 0 1-4.191 4.192h-3.675a.861.861 0 1 1 0-1.723h3.675a2.47 2.47 0 0 0 2.468-2.469V7.207a2.47 2.47 0 0 0-2.468-2.469z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.962 7.38a.517.517 0 1 0 0-1.034.517.517 0 0 0 0 1.033m-1.206-.518a1.206 1.206 0 1 1 2.411 0 1.206 1.206 0 0 1-2.411 0M10.892 1.737c-.888.042-1.557.18-1.99.455l-.019.012c-.4.24-.746.56-1.167.95l-.26.239c-.507.464-1.132 1-1.937 1.293a.861.861 0 1 1-.588-1.619c.457-.166.866-.49 1.363-.945l.218-.201c.416-.387.912-.848 1.476-1.188C8.817.209 9.866.06 10.81.017a29 29 0 0 1 1.911 0c.319.006.62.013.886.013.656 0 1.203.245 1.654.55.436.298.828.685 1.165 1.023.739.739 1.28 1.273 1.971 1.436a.861.861 0 0 1-.394 1.676c-1.189-.28-2.052-1.147-2.682-1.78q-.057-.06-.113-.114c-.351-.352-.634-.624-.916-.816-.267-.181-.48-.253-.685-.253q-.523-.001-1.024-.015a24 24 0 0 0-1.692 0",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.35 2.327a.17.17 0 0 0-.173.172v1.378a.861.861 0 1 1-1.723 0V2.499A1.89 1.89 0 0 1 19.35.604h1.263A1.89 1.89 0 0 1 22.507 2.5V4.45a.861.861 0 0 1-1.722 0V2.499a.17.17 0 0 0-.173-.172z",
    clipRule: "evenodd"
  })));
};
export default SvgCamera;